// extracted by mini-css-extract-plugin
export default {"block-divider-dropdown-content":"AddGroupButton_block-divider-dropdown-content__Pj9ku","blockDividerDropdownContent":"AddGroupButton_block-divider-dropdown-content__Pj9ku"};